function set(data, callback) {
	setTimeout(() => callback(), 20);
}

function get(data, callback) {
	setTimeout(() => callback({}), 20);
}

const storage = {
	sync: {
		set,
		get,
	},
};

if (window.chrome) {
	// The browser has a chrome object.
	window.chrome.storage = storage;
} else {
	// Browsers other than chrome need this defined.
	window.chrome = {
		storage,
	};
}



// WEBPACK FOOTER //
// ./src/utils/fakeChrome.js